export default function ProfileWorkTab({ details }) {
  console.log("details", details);
  return (
    <>
      <div className="profile-tab-all">
        <div className="profile-single-all">
          <span>Skills</span>
          <div className="profile-skills-wrapper profile-rounded-div-wrapper">
            {details.skills.map((skill) => (
              <div className=" rounded-single-item" key={skill.id}>
                {skill.name}
              </div>
            ))}
          </div>
        </div>
        <div className="profile-single-all profile-ideal-companies">
          <span>Interested in working for</span>
          {details.ideal_companies.length > 0 ? (
            <div className="profile-rounded-div-wrapper">
              {details.ideal_companies.map((company, index) => (
                <div className="rounded-single-item" key={index}>
                  {company.name}
                </div>
              ))}
            </div>
          ) : (
            <p>No companies.</p>
          )}
        </div>
        {details.other_companies.length !== 0 && (
          <div className="profile-single-all profile-ideal-companies">
            <span>Other companies</span>
            <div className="profile-rounded-div-wrapper">
              {details.other_companies.map((company, index) => (
                <div className="rounded-single-item" key={index}>
                  {company}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="separator"></div>
        <div className="profile-single-all">
          <span>Preferences</span>
          {details.preferences.length !== 0 ? (
            <>
              <div className="profile-rounded-div-wrapper">
                {details.preferences.map((curr, index) => (
                  <div className="rounded-single-item" key={index}>
                    {curr.name}
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p>No preferences.</p>
          )}
          <div className="separator"></div>
        </div>
        <div className="profile-single-all">
          <div className="sallary-wrapper">
            <div className="minimun-wrapper-all">
              <span>Minimum base salary</span>
              {details.profile.minimum_salary ? (
                <p>${details.profile.minimum_salary}</p>
              ) : (
                <p>No data.</p>
              )}
            </div>
            <div className="minimun-wrapper-all">
              <span>Minimum bonus / comission</span>
              {details.profile.minimum_bonus ? (
                <p>${details.profile.minimum_bonus}</p>
              ) : (
                <p>No data.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
